// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"99a8e4f4","835":"f808a06c"}[chunkId] + ".chunk.js";
};